import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import cx from 'classnames';
import styles from './DealerLocatorNonInstantAccessWarning.module.scss';
export const DealerLocatorNonInstantAccessWarning = ({ children }) => {
    return (_jsxs("div", { className: styles['mainContainer'], children: [_jsx(CatIconWarningTriangle, { color: "error", size: "lg" }), _jsx("p", { className: cx('cat-u-theme-typography-label-sm m-0 ms-2', styles['wording']), children: children })] }));
};
